import { useMutation } from '@tanstack/react-query';
import { useGrowthQuery } from '@/data/useGrowthQuery';
import { growthKeys } from '@/data/queryKeys';
import { useNotify } from '@/data/notifications';
import {
  exportMonthlyReportPdf,
  fetchMonthlyReport,
  fetchMonthlyReportMonths,
} from '../api';

export function useMonthlyReport(month?: string) {
  return useGrowthQuery({
    queryKey: growthKeys.monthlyReport(month),
    queryFn: () => fetchMonthlyReport(month),
    refetchInterval: (query) => (query.state.data?.generating ? 3000 : false),
  });
}

export function useMonthlyReportMonths() {
  return useGrowthQuery({
    queryKey: growthKeys.monthlyReportMonths(),
    queryFn: fetchMonthlyReportMonths,
  });
}

export function useMonthlyReportMutations() {
  const notify = useNotify();

  const exportPdf = useMutation({
    mutationFn: exportMonthlyReportPdf,
    onSuccess: () => notify.success('Report export started'),
    onError: (e) => notify.error(e),
  });

  return { exportPdf };
}
